module.exports = __webpack_public_path__ + "img/packages/labels-preview-mobile.2fc8ee.png";